export default "__VITE_ASSET__DehqNMh2__"